import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ContactService } from '../../../home/services/contact.service';
import { ProfileService } from '../../../home/services/profile.service';
import { LoginService } from '../../../services/login.service';
import { HeaderService } from '../../services/header.service';
import { ConfirmationComponent } from '../confirmation/confirmation.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  selectedTab: number = 1;
  showSignout: boolean = false;
  displayOnlyLogo: boolean = false;
  subscription: Array<Subscription> = [];
  userDetails: any;
  errorMsgs: any;
  profileImg: string = './images/default-profile.svg';
  displayMobileMenu: boolean = false;
  showNotification: boolean = false;
  unreadNotificationCount: number = 0;
  totalNotificationCount: number = 0;
  notificationsDetails: any;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private headerService: HeaderService,
    private loginService: LoginService,
    private toastrService: ToastrService,
    private translate: TranslateService,
    private contactService: ContactService,
    private profileService: ProfileService,
    private cdr: ChangeDetectorRef
  ) {
    this.subscription.push(translate.get(['toasterStatus']).subscribe((data: any) => {
      this.errorMsgs = data
    }));
  }

  ngOnInit() {
    this.subscription.push(this.headerService.headerDetails.subscribe((data: any) => {
      if (data) {
        this.displayOnlyLogo = data.displayOnlyLogo;
        this.cdr.detectChanges();
      }
    }))

    if (sessionStorage.getItem('userDetails')) {
      this.userDetails = JSON.parse(atob(sessionStorage.getItem('userDetails')!));
      if (this.userDetails.profileImage && this.userDetails.profileImage != "")
        this.profileImg = 'data:image/png;base64,' + this.userDetails.profileImage;
    }

    this.subscription.push(this.profileService.userDetails.subscribe((data: any) => {
      if (data) {
        this.profileImg = 'data:image/png;base64,' + data.profileImage;
      }
    }))

    let url = this.router.url.split('/');
    if (url[url.length - 1] == 'profile') {
      this.selectedTab = 2
    }
    else {
      this.selectedTab = 1;
    }

    this.subscription.push(this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        let url = event.url.split('/');
        if (url[url.length - 1] == 'profile') {
          this.selectedTab = 2
        }
        else {
          this.selectedTab = 1;
        }
      }
    }));

    let urlArray = this.router.url.split('/');
    if (this.userDetails && urlArray[urlArray.length - 1] != 'notifications') {
      this.getNotifications()
    }

    this.subscription.push(this.headerService.changeNotification.subscribe((res: any) => {
      if (res) {
        this.getNotifications()
      }
    }))
  }

  getNotifications() {
    let body = {
      "pageSize": 3,
      "pageNumber": 1
    }
    this.headerService.getNotifications(body).subscribe((res: any) => {
      this.headerService.updateNotificationLoaded(true);
      if (res && res.status && res.status.isSuccess) {
        this.notificationsDetails = res.content;
        this.unreadNotificationCount = this.notificationsDetails.unReadNotifications;
        this.totalNotificationCount = this.notificationsDetails.totalNotifications;
      }
    })
  }

  tabClick(index: number) {
    this.selectedTab = index;
    if (index == 1) {
      this.contactService.updateContactType('');
      this.router.navigate(['/home/account']);
    }
    else if (index == 2) {
      this.router.navigate(['/home/profile']);
    }
    this.displayMobileMenu = false;
  }

  signoutClick() {
    this.showSignout = !this.showSignout;
  }

  logout() {
    this.showSignout = false;
    this.displayMobileMenu = false;
    let data = {
      icon: './images/logout-conf.svg',
      content: 'header.logoutContent',
      btnText1: 'header.confirm',
      btnText2: 'header.cancel'
    }
    this.dialog.open(ConfirmationComponent, { height: '464px', width: '612px', data: data }).afterClosed().subscribe((res: any) => {
      if (res) {
        // let body = {
        //   "icNumber": this.userDetails?.userName
        // }
        this.loginService.logout().subscribe((data: any) => {
          if (data && data.status && data.status.isSuccess) {
            this.router.navigate(['/login']);
            localStorage.removeItem('encryptionKey');
            localStorage.removeItem('authToken');
            sessionStorage.removeItem('userDetails');
            // localStorage.clear();
            if (this.dialog.openDialogs.length > 0) {
              this.dialog.closeAll();
            }
            this.toastrService.success(data.status.statusMessage, this.errorMsgs['toasterStatus'].success)
          }
          else {
            this.toastrService.error(data.status.statusMessage, this.errorMsgs['toasterStatus'].error);
          }
        })
      }
    })
  }

  mobileMenuClick() {
    this.displayMobileMenu = true;
  }

  closeMobileMenu() {
    this.displayMobileMenu = false;
  }

  notificationClick() {
    this.showNotification = !this.showNotification;

  }

  notificationCenterClick() {
    this.router.navigate(['/home/notifications']);
    this.displayMobileMenu = false;
  }

  notificationOuterClick() {
    this.showNotification = false;
  }

  ngOnDestroy() {
    this.headerService.updateNotificationLoaded(false);
    this.headerService.updateNotification(false);
    if (this.subscription && this.subscription.length) {
      this.subscription.forEach(ele => ele.unsubscribe());
    }
  }
}
